import React, { useMemo } from 'react';
import { Form, Select } from 'antd';
import dayjs from 'dayjs';
import { timezones } from '../../consts';
import utc from 'dayjs/plugin/utc'; 
import timezone from 'dayjs/plugin/timezone';

dayjs.extend( utc );
dayjs.extend( timezone ); 

const TimezoneSelectFormItem = ( { onChange, includeOffset = true, disabled } ) => {

    const options = useMemo( () => {
        const humanizeTz = tz => tz.replaceAll( '/', ' / ' ).replaceAll( '_', ' ' );
        if ( includeOffset ) {
            const groups = {};
            timezones.forEach( t => {
                const offsetMinutes = dayjs().tz( t ).utcOffset();
                const offset = `UTC${ dayjs().tz( t ).format( 'Z' ) }`;
                if ( !groups[ offset ] ) {
                    groups[ offset ] = { offset, offsetMinutes, items: [] };
                }
                groups[ offset ].items.push( t );
            } );

            return Object.values( groups )
                .sort( ( a, b ) => a.offsetMinutes - b.offsetMinutes )
                .map( g => ( {
                    label: g.offset,
                    options: g.items
                        .sort( ( a, b ) => a.localeCompare( b ) )
                        .map( t => {
                            const label = humanizeTz( `${ t } (${ g.offset })` );
                            return { value: t, label, selectedLabel: label };
                        } )
                } ) );
        } else {
            const regionRegex = /^(\w+)\//;
            const groups = {};
            timezones.forEach( t => {
                if ( t === 'UTC' ) {return;}
                const region = t.match( regionRegex )?.[ 1 ] ?? 'Other';
                if ( !groups[ region ] ) {
                    groups[ region ] = [];
                }
                groups[ region ].push( t );
            } );

            const groupedOptions = Object.keys( groups )
                .sort( ( a, b ) => a.localeCompare( b ) )
                .map( region => ( {
                    label: region,
                    options: groups[ region ]
                        .map( t => ( { value: t, label: humanizeTz( t.replace( regionRegex, '' ) ), selectedLabel: humanizeTz( t ) } ) )
                        .sort( ( a, b ) => a.label.localeCompare( b.label ) )
                } ) );

            return [
                ...( timezones.includes( 'UTC' ) ? [ { value: 'UTC', label: 'UTC', selectedLabel: 'UTC' } ] : [] ),
                ...groupedOptions
            ];
        }
    }, [ includeOffset ] );
    
    return (
        <Form.Item 
            name="timezone"
            label="Time Zone"
        >
            <Select
                mode="single" 
                showSearch="true"
                disabled={ disabled }
                onChange={ onChange }
                popupMatchSelectWidth={ false }
                optionLabelProp='selectedLabel'
                placeholder="Select" 
                options={ options }
            >
            </Select>
        </Form.Item>
    );
};

export default TimezoneSelectFormItem;
